import { useEffect } from 'react';

const useTawkTo = () => {
  useEffect(() => {
    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = 'https://embed.tawk.to/68f630697d479d194d3bac0a/1j80qq7n1';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode?.insertBefore(s1, s0);

    return () => {
      // Clean up the script when the component unmounts
      if (s1.parentNode) {
        s1.parentNode.removeChild(s1);
      }
    };
  }, []);
};

export default useTawkTo;
